import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://b.supchats.com';

const ContactLogPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedIds, setSelectedIds] = useState([]);
  const [copyStatus, setCopyStatus] = useState('');

  const loadData = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await axios.get(`${API_URL}/admin/contact-requests`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('admin_token')}`,
        },
      });
      if (res.data && res.data.ok) {
        setItems(res.data.items || []);
        setSelectedIds([]);
      } else {
        setError(res.data?.detail || 'Ошибка загрузки обращений');
      }
    } catch (e) {
      setError(e.response?.data?.detail || 'Ошибка сети при загрузке обращений');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const toggleSelectAll = () => {
    if (selectedIds.length === items.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(items.map((item) => item.id));
    }
  };

  const toggleSelectOne = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const formatDateTime = (value) => {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    const pad = (n) => String(n).padStart(2, '0');
    const day = pad(d.getDate());
    const month = pad(d.getMonth() + 1);
    const year = d.getFullYear();
    const hours = pad(d.getHours());
    const minutes = pad(d.getMinutes());
    return `${day}.${month}.${year} ${hours}:${minutes}`;
  };

  const handleCopySelected = async () => {
    if (!selectedIds.length) return;
    try {
      const lines = items
        .filter((item) => selectedIds.includes(item.id))
        .map((item) => {
          const date = formatDateTime(item.created_at);
          const parts = [
            date,
            item.email || '',
            item.extra_contact || '',
            item.subject || '',
          ].filter(Boolean);
          return parts.join(' ');
        });

      const text = lines.join('\n\n');
      await navigator.clipboard.writeText(text);
      setCopyStatus(`Скопировано заявок: ${selectedIds.length}`);
      setTimeout(() => setCopyStatus(''), 3000);
    } catch (e) {
      setCopyStatus('Не удалось скопировать в буфер обмена.');
      setTimeout(() => setCopyStatus(''), 3000);
    }
  };

  const handleDeleteSelected = async () => {
    if (!selectedIds.length) return;

    const count = selectedIds.length;
    const confirmed = window.confirm(
      `Вы действительно хотите безвозвратно удалить ${count} заявк${
        count === 1 ? 'у' : count < 5 ? 'и' : ''
      }?`
    );
    if (!confirmed) return;

    try {
      setLoading(true);
      await axios.delete(`${API_URL}/admin/contact-requests`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('admin_token')}`,
        },
        data: { ids: selectedIds },
      });
      await loadData();
    } catch (e) {
      setError(e.response?.data?.detail || 'Ошибка удаления обращений');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-section">
      <div className="admin-section-header">
        <h2>Журнал обращений</h2>
        <div className="contact-log-actions">
          <button
            type="button"
            className="contact-log-btn"
            onClick={handleCopySelected}
            disabled={loading || selectedIds.length === 0}
          >
            Копировать
          </button>
          <button
            type="button"
            className="contact-log-btn delete"
            onClick={handleDeleteSelected}
            disabled={loading || selectedIds.length === 0}
          >
            Удалить
          </button>
          <button
            type="button"
            className="contact-log-btn"
            onClick={loadData}
            disabled={loading}
          >
            Обновить
          </button>
        </div>
      </div>

      {copyStatus && (
        <div className="contact-log-status">
          {copyStatus}
        </div>
      )}

      {error && (
        <div className="admin-message error">
          {error}
        </div>
      )}

      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th className="contact-log-select-col">
                <input
                  type="checkbox"
                  checked={items.length > 0 && selectedIds.length === items.length}
                  onChange={toggleSelectAll}
                />
              </th>
              <th>Дата</th>
              <th>Email</th>
              <th>Доп. контакт</th>
              <th>Суть обращения</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && !loading && (
              <tr>
                <td colSpan={5} style={{ textAlign: 'center', padding: '16px' }}>
                  Пока нет обращений.
                </td>
              </tr>
            )}
            {items.map((item) => (
              <tr key={item.id} className={selectedIds.includes(item.id) ? 'contact-log-row selected' : 'contact-log-row'}>
                <td className="contact-log-select-col">
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(item.id)}
                    onChange={() => toggleSelectOne(item.id)}
                  />
                </td>
                <td>
                  {formatDateTime(item.created_at)}
                </td>
                <td>{item.email}</td>
                <td>{item.extra_contact}</td>
                <td className="contact-log-subject">
                  <div className="contact-log-subject-content">
                    {item.subject}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContactLogPage;

